export const FEEDBACK_TYPE = {
  POSITIVE: 'p',
  NEGATIVE: 'n',
  RANDOM: 'r'
};

export const FEEDBACK_SELECT_TYPE = {
  DEFAULT: 'default',
  CUSTOM: 'custom'
};

export const FEEDBACK_TYPE_MENU = [
  {
    value: FEEDBACK_TYPE.POSITIVE,
    label: 'Positive'
  },
  {
    value: FEEDBACK_TYPE.NEGATIVE,
    label: 'Negative'
  }
];
